import { gql } from 'graphql-request';
import purchaseGraphqlClient from './purchaseGraphqlClient';

export const AUTH_FINALIZE_PURCHASE = gql`
  mutation AUTH_FINALIZE_PURCHASE($uuid: String!, $params: AuthFinalizePurchaseInput!) {
    auth_finalize_purchase(uuid: $uuid, params: $params) {
      uuid
      stripe_invoice
      stripe_invoice_id
    }
  }
`;

export interface AuthFinalizePurchaseInput {
  stripe_payment_method_id: string;
}

export interface AuthFinalizePurchaseResponse {
  uuid: string;
  stripe_invoice?: any;
  stripe_invoice_id?: string;
}

interface AuthFinalizePurchaseGQLResponse {
  auth_finalize_purchase: AuthFinalizePurchaseResponse;
}

export async function authFinalizePurchase(
  token: string | null,
  uuid: string,
  params: AuthFinalizePurchaseInput
): Promise<AuthFinalizePurchaseResponse> {
  if (!token) {
    throw new Error('Authentication token is required for authenticated purchase finalization');
  }

  console.log('authFinalizePurchase: Finalizing purchase with uuid:', uuid, 'params:', params);

  const data = await purchaseGraphqlClient.request<AuthFinalizePurchaseGQLResponse>(
    AUTH_FINALIZE_PURCHASE,
    { uuid, params },
    token
  );

  console.log('authFinalizePurchase: Response received:', data);

  return data.auth_finalize_purchase;
}